module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-10"
  }, [(_vm.errMsg) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.errMsg))]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.name),
      expression: "template.name"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.template.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.fileId),
      expression: "template.fileId"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.template.fileId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "fileId", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._l((_vm.template.sections), function(s, i) {
    return _c('templateSection', {
      key: i,
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "section": s
      },
      on: {
        "delete": function($event) {
          return _vm.removeSec(i)
        },
        "moveUp": function($event) {
          return _vm.moveSec(i, -1)
        },
        "moveDown": function($event) {
          return _vm.moveSec(i, 1)
        }
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "column col-2"
  }, [_c('div', {
    staticClass: "bg-secondary docs-block"
  }, [(_vm.template.fileId) ? _c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": _vm.viewTemplate
    }
  }, [_vm._v("View Template")]) : _vm._e(), _vm._v(" "), (_vm.template._id) ? _c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": _vm.del
    }
  }, [_vm._v("Delete Template")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("Add Section")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("File id")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10512432"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/edit_template.vue
// module id = 476
// module chunks = 1